import { useCallback, useContext } from 'react';

import PropTypes from 'prop-types';

import { AuthContext } from '../../../../../actions/auth-context';
import {
  startSpreadEditingTheOrder,
  finishSpreadEditingTheOrder,
} from '../../../../../actions/order.service';
import ActionModal from './ActionModal';

const SpreadEditModal = ({ order, setOrder }) => {
  const { setLoading } = useContext(AuthContext);

  const uploadOrder = useCallback((response) => {
    if (!response.error) {
      response.delivery_date = new Date(response.delivery_date);

      if (response.payment_first_date) {
        response.payment_first_date = new Date(
          response.payment_first_date.replace(/-/g, ',')
        );
      }

      setOrder(response);
    }
  }, []);

  const startSpreadEditingOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await startSpreadEditingTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  const finishSpreadEditingOrder = useCallback(async (data) => {
    setLoading(true);

    const response = await finishSpreadEditingTheOrder(data.order_id, data);

    uploadOrder(response);

    setLoading(false);
  }, []);

  return (
    <>
      <ActionModal
        modal_id="modal-start-spread-editing-order"
        title="iniciar edição de lâminas do pedido?"
        action={startSpreadEditingOrder}
        order={order}
      />

      <ActionModal
        modal_id="modal-finish-spread-editing-order"
        title="finalizar edição de lâminas do pedido?"
        action={finishSpreadEditingOrder}
        order={order}
      />
    </>
  );
};

SpreadEditModal.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.string,
    order_status: PropTypes.string,
  }).isRequired,
  setOrder: PropTypes.func.isRequired,
};

export default SpreadEditModal;
